var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-message"},[(_vm.serviceCount.length == 0)?_c('div',{staticClass:"emptyMessage"},[_vm._v(" 暂无数据 ")]):_vm._e(),(_vm.serviceCount.length > 0)?_c('div',{staticStyle:{"height":"15.083333rem","width":"28.583333","margin":"0 auto"},attrs:{"id":"container"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }